/**
 * The public landing page — for most borrowers, the whole of their experience
 * of this software.
 *
 * Section order comes from `settings/app.landingLayout` via the public API,
 * so an admin can rearrange blocks without a deploy.
 */

import { PublicShell } from '../../app/PublicShell'
import { useSavingsPlans } from './useSavingsPlans'
import { LandingPageContent } from './LandingPageContent'
import { FundImpactWelcomeModal } from './FundImpactWelcomeModal'

export function LandingPage() {
  const { plans, sectionOrder, fundImpact, loading: plansLoading } = useSavingsPlans()

  return (
    <PublicShell>
      <FundImpactWelcomeModal fundImpact={fundImpact} loading={plansLoading} />
      <LandingPageContent
        sectionOrder={sectionOrder}
        plans={plans}
        plansLoading={plansLoading}
        fundImpact={fundImpact}
      />
    </PublicShell>
  )
}
